// src/components/LoaderOverlay.js
import React from "react";
import "./LoaderOverlay.css"; // style separate rakhenge

const LoaderOverlay = ({ loading, message = "Please wait..." }) => {
  if (!loading) return null; // agar loading false hai, kuch mat dikhao

  return (
    <div className="overlay-loader">
      <div className="loader-box">
        <div className="spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoaderOverlay;
